import { render, staticRenderFns } from "./AvvEdit.vue?vue&type=template&id=9b6cadbe"
import script from "./AvvEdit.vue?vue&type=script&lang=js"
export * from "./AvvEdit.vue?vue&type=script&lang=js"
import style0 from "./AvvEdit.vue?vue&type=style&index=0&id=9b6cadbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports